import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { SidebarMenuButton, useSidebar } from '@/components/ui/sidebar';

interface LanguageSwitcherProps {
  variant?: 'sidebar' | 'dropdown';
}

export function LanguageSwitcher({ variant = 'sidebar' }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.language?.startsWith('pt') ? 'pt-BR' : 'en';
  const nextLanguage = currentLanguage === 'pt-BR' ? 'en' : 'pt-BR';
  const languageLabel = currentLanguage === 'pt-BR' ? 'English' : 'Português';

  const toggleLanguage = () => {
    i18n.changeLanguage(nextLanguage);
  };

  if (variant === 'dropdown') {
    return (
      <div 
        className="flex items-center w-full cursor-pointer px-2 py-1.5"
        onClick={toggleLanguage}
      >
        <Globe className="w-4 h-4 mr-2" />
        <span className="flex-1">{t('settings.language')}</span>
        <span className="text-xs text-muted-foreground">{languageLabel}</span>
      </div>
    );
  }

  return (
    <SidebarMenuButton
      onClick={toggleLanguage}
      tooltip={`${t('settings.language')}: ${languageLabel}`}
      className="w-full"
    >
      <Globe className="h-5 w-5" />
      <span className="flex-1">{t('settings.language')}</span>
      <span className="text-xs text-muted-foreground">{languageLabel}</span>
    </SidebarMenuButton>
  );
}